// ============================================================================
// retryVarakozas.js — a kért (új)fordítás gombja addig marad "folyamatban", amíg a fordítás ténylegesen le nem zárul
// (2026-10-16, iPhone-os jelzés: a fordítás kérése után "nem történt semmi" a képernyőn).
//
// A MIÉRT: a kérés (retryTranslation) csak SORBA ÁLLÍTJA a fordítást, és azonnal visszatér; a gomb eddig ekkor már vissza is
// állt, a fordítás eredménye pedig másodpercekkel később, a figyelőn át érkezett - közben semmi sem utalt arra, hogy a kérés
// elindult. Most a gomb "folyamatban" állapota addig tart, amíg az üzenet állapota folyamatban -> kész / hiba nem lesz.
//
// Tiszta döntés (tesztelhető): a figyelő minden üzenetfrissítésénél megkérdezzük, mely kérések zárulhatnak le.
// ============================================================================

/** Ennyi idő után a gomb mindenképp feloldódik (a háttérben elakadt fordítás ne tartsa örökre tiltva). */
export const RETRY_MAX_VARAKOZAS_MS = 60 * 1000;
/** Ha ennyi ideig sem látszott a "folyamatban" állapot (pl. a kérés elutasítódott / azonnal kész lett), a gomb feloldódik. */
export const RETRY_LATAS_MAX_MS = 20 * 1000;

const FOLYAMATBAN = new Set(["pending", "processing", "retry_wait"]);

/**
 * @param {Map<string, {kezdet: number, lattFolyamatban: boolean}>} kerelmek  A MÓDOSÍTJA: a látott "folyamatban" jelzést rögzíti.
 * @param {Array<{messageId: string, translationStatus?: string}>} uzenetek az éppen betöltött üzenetek
 * @param {number} most
 * @returns {string[]} azok az azonosítók, amelyek gombja feloldható
 */
export function felszabaditando(kerelmek, uzenetek, most) {
  const ki = [];
  const allapot = new Map((uzenetek || []).map((u) => [u.messageId, u.translationStatus]));
  for (const [id, k] of kerelmek) {
    const eltelt = most - k.kezdet;
    const st = allapot.get(id);
    if (FOLYAMATBAN.has(st)) k.lattFolyamatban = true;
    const lezarult = allapot.has(id) && !FOLYAMATBAN.has(st) && k.lattFolyamatban;
    if (!allapot.has(id) || lezarult || eltelt >= RETRY_MAX_VARAKOZAS_MS || (!k.lattFolyamatban && eltelt >= RETRY_LATAS_MAX_MS)) ki.push(id);
  }
  return ki;
}
